import { StatusBar } from "expo-status-bar";
import React, { useRef, useState } from "react";
import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Dimensions,
} from "react-native";
import Dawer from "../../component/drawer";
import Admin from "../../component/admin";
import InputFree from "../../component/inputfree";
import { tokenState } from "../../reducer/reducer/reducer/Atom";
import { useRecoilState } from "recoil";
import { apiservice } from "../../service/service";
const { width, height } = Dimensions.get("window");

export default function createlv({ navigation }) {
  const [token, setToken] = useRecoilState(tokenState);
  const [body1, setbody1] = useState({ coinlv: "", coindis: "", cal: "" });
  const [body, setbody] = useState({
    lv: "",
    description: "",
    reward: {},
  });

  return (
    <View style={styles.container}>
      <Dawer navigation={navigation} />
      <View style={styles.back}>
        <Admin />
        <View style={styles.viewfree}>
          <Text style={styles.textfree}>
            LVEEL{" "}
            <Text style={styles.textfree1}>
              / <Text style={styles.textfree1}>ADD</Text>
            </Text>
          </Text>
          <View style={styles.viewtouch}>
            <TouchableOpacity
              onPress={async () => {
                let data = { ...body, reward: body1 };
                const response = await apiservice({
                  path: "/banner/create_LvList",
                  method: "post",
                  body: data,
                  token: token?.accessToken,
                });

                if (response.status == 200) {
                  navigation.goBack();
                }
              }}
              style={styles.touchadd}
            >
              <Text style={styles.textadd}>บันทึก</Text>
            </TouchableOpacity>
            <TouchableOpacity
              onPress={() => {
                navigation.goBack();
              }}
              style={styles.touchadd}
            >
              <Text style={styles.textadd}>ยกเลิก</Text>
            </TouchableOpacity>
          </View>
        </View>
        <View style={styles.view}>
          <View style={styles.viewin}>
            <InputFree
              name="เลเวล"
              placeholder="กรอกเป็นตัวเลข"
              onChangeText={(text) => {
                setbody({ ...body, lv: text });
              }}
            />
            <InputFree
              name="เงื่อนไขการรับของรางวัล"
              placeholder="Lv.**"
              onChangeText={(text) => {
                setbody({ ...body, description: text });
              }}
            />
          </View>
          <View style={styles.viewin}>
            <InputFree
              name="โกลด์ จากเลเวลอัพ"
              placeholder="กรอกเป็นตัวเลข"
              onChangeText={(text) => {
                setbody1({ ...body1, coinlv: text });
              }}
            />
            <InputFree
              name="โกลด์ พิเศษ"
              placeholder="กรอกรายละเอียด"
              onChangeText={(text) => {
                setbody1({ ...body1, coindis: text });
              }}
            />
            <InputFree
              name="แคลอรี่"
              placeholder="กรอกรายละเอียด"
              onChangeText={(text) => {
                setbody1({ ...body1, cal: text });
              }}
            />
          </View>
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: width,
    height: height,
    backgroundColor: "#F3F3F3",
    flexDirection: "row",
  },
  back: {
    width: width * 0.85,
    height: height,
    paddingHorizontal: width * 0.01,
  },
  viewfree: {
    justifyContent: "space-between",
    width: width * 0.83,
    flexDirection: "row",
  },
  textfree: {
    fontFamily: "Prompt-Regular",
    fontSize: 25,
    color: "#000",
    fontWeight: "bold",
    alignSelf: "center",
  },
  textfree1: {
    fontFamily: "Prompt-Regular",
    fontSize: 20,
    color: "#000",
    alignSelf: "center",
  },
  touchadd: {
    width: 150,
    height: 40,
    justifyContent: "center",
    backgroundColor: "#fff",
    alignSelf: "center",
  },
  textadd: {
    fontFamily: "Prompt-Regular",
    fontSize: 16,
    color: "#172B4D",
    alignSelf: "center",
  },
  viewtouch: {
    flexDirection: "row",
    width: width * 0.35,
    justifyContent: "space-between",
    marginRight: 20,
  },
  view: {
    width: width * 0.83,
    height: height * 0.8,
    borderWidth: 0.05,
    borderColor: "#00000010",
    backgroundColor: "#fff",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
    marginTop: 10,
    flexDirection: "row",
    justifyContent: "space-between",
  },
  viewin: {
    width: width * 0.41,
    padding: 20,
    backgroundColor: "#ffffff",
  },
  kob: {
    height: 120,
    fontFamily: "Prompt-Regular",
    borderWidth: 1,
    borderColor: "#ccc",
    paddingLeft: 10,
    borderRadius: 5,
    marginTop: 20,
    marginBottom: 10,
  },
  textname: {
    fontSize: 18,
    color: "#000000",
    fontFamily: "Prompt-Regular",
  },
  style: {
    flexDirection: "row",
    marginTop: 5,
  },
  viewimg: {
    width: 150,
    height: 70,
    borderWidth: 0.5,
    borderColor: "#DBDBDB",
    borderRadius: 5,
    alignSelf: "center",
  },
  tochup: {
    width: 120,
    height: 40,
    borderRadius: 5,
    borderWidth: 0.5,
    borderColor: "#DBDBDB",
    justifyContent: "center",
  },
  textup: {
    fontSize: 16,
    color: "#000000",
    fontFamily: "Prompt-Regular",
    alignSelf: "center",
  },
  textRe: {
    fontSize: 12,
    color: "#000000",
    fontFamily: "Prompt-Regular",
    marginTop: 10,
  },
  touchlong: {
    width: width * 0.18,
    height: 30,
    borderWidth: 1,
    borderColor: "#ccc",
    paddingLeft: 10,
    borderRadius: 5,
  },
  touchheigh: {
    width: width * 0.38,
    height: 30,
    borderWidth: 1,
    borderColor: "#ccc",
    paddingLeft: 10,
    borderRadius: 5,
  },
  input: {
    width: width * 0.38,
    height: 33,
    fontFamily: "Prompt-Regular",
    borderWidth: 1,
    borderColor: "#ccc",
    paddingLeft: 10,
    borderRadius: 5,
    marginTop: 5,
    marginBottom: 10,
  },
  viewinput: {
    flexDirection: "row",
    width: width * 0.36,
    justifyContent: "space-between",
    paddingTop: 15,
  },
  botton: {
    alignSelf: "center",
    marginLeft: -25,
  },
  viewimglogo: {
    width: 70,
    height: 70,
    borderWidth: 0.5,
    borderColor: "#DBDBDB",
    borderRadius: 5,
    alignSelf: "center",
  },
  logo: {
    width: width * 0.24,
    height: 85,
    fontFamily: "Prompt-Regular",
    borderWidth: 1,
    borderColor: "#ccc",
    paddingLeft: 10,
    borderRadius: 5,
    marginTop: 10,
    marginBottom: 10,
    flexDirection: "row",
  },
  touchsmall: {
    backgroundColor: "#FCC81D",
    width: 60,
    height: 30,
    borderRadius: 5,
    borderWidth: 0.5,
    borderColor: "#DBDBDB",
    justifyContent: "center",
  },
  textsmall: {
    fontSize: 12,
    color: "#000000",
    fontFamily: "Prompt-Regular",
    alignSelf: "center",
  },
  textmini: {
    fontSize: 9,
    color: "#000000",
    fontFamily: "Prompt-Regular",
    marginTop: 10,
  },
  backmodal: {
    width: width,
    height: height,
    backgroundColor: "#000000bb",
    justifyContent: "center",
  },
  viewinmodail: {
    width: width * 0.5,
    alignSelf: "center",
    justifyContent: "center",
    backgroundColor: "#fff",
    paddingVertical: 30,
  },
  imgko: {
    width: 25,
    height: 25,
    position: "absolute",
    alignSelf: "center",
  },
  line: {
    width: width * 0.5,
    borderBottomWidth: 0.5,
    borderColor: "#44444440",
    marginTop: 10,
  },
  liner: {
    flexDirection: "row",
    width: width * 0.48,
    justifyContent: "space-between",
    height: 40,
    borderLeftWidth: 1,
    borderLeftColor: "#2DCE98",
    marginTop: 10,
    alignSelf: "center",
  },
  ok: {
    width: 40,
    height: 40,
    borderWidth: 0.5,
    borderColor: "#DBDBDB",
    borderRadius: 5,
    justifyContent: "center",
    marginRight: 10,
  },
});
